import { Dispatch } from 'react';
import { TServiceClientActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { UPDATE_SERVICE_CLIENT_VEHICLE } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { TCreateVehicleFormikValues } from 'src/views/serviceClient/components/types';

export const updateServiceClientVehicle = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    serviceClientId: string,
    vehicleId: string,
    values: TCreateVehicleFormikValues
): Promise<boolean | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            `/service-clients/${serviceClientId}/vehicle/${vehicleId}/update`,
            { ...values },
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({
            type: UPDATE_SERVICE_CLIENT_VEHICLE,
            payload: res.data.data,
        });

        return true;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
